import { createContainer } from '@react-apps/core';

/**
 * Container de DI central da aplicação — o ponto onde todos os módulos
 * registram suas dependências (via `AppModule.register`) e de onde a
 * presentation as resolve.
 *
 * É um módulo "folha": não importa nenhum módulo de feature, para evitar
 * ciclos de import. A população acontece no bootstrap (`app/bootstrap.ts`).
 */
export const container = createContainer();
